import { composeValueSet } from "@intocare/datatypes/lib/value-set";

import { ASSESSMENT_TYPE } from "../../code-system/assessment-type";

export const ASSESSMENT_TYPE_MODEL = composeValueSet({
	name: "ASSESSMENT_TYPE_MODEL",
	description: "Current selection of assessment types an assessment can be of.",
	system: ASSESSMENT_TYPE,
	include: [
		"BRADEN",
		"DOLOPLUS-2",
		"IDDSI",
		"MMSE",
		"MNA",
		"NORTON",
		"OHAT",
		"PACSLAC-D",
		"PAINAD",
		"TIMED_CHAIR_STAND",
		"TIMED_GET_UP_AND_GO",
		"TINETTI",
		"VAS",
	],
});
